import { createContext, useContext } from 'react'
import { IProduct } from '../types/IProduct'

export interface IOrderProduct {
  id: string
  quantity: number
}

export interface ICartProduct {
  product: IProduct
  data: IOrderProduct
}

interface ICart {
  products: IProduct[] | null
  cartProducts: ICartProduct[]
  addToCart: (id: string, quantity: number) => void
  updateCartProduct: (id: string, quantity: number) => void
  removeFromCart: (id: string) => void
  isVisibleCart: boolean
  setIsVisibleCart: (value: boolean) => void
  reset: () => void
}

const CartContext = createContext<ICart>({
  products: [],
  cartProducts: [],
  addToCart: () => {},
  removeFromCart: () => {},
  updateCartProduct: () => {},
  isVisibleCart: false,
  setIsVisibleCart: () => {},
  reset: () => {},
})

export const useCart = (products?: ICartProduct[]) => {
  const cartContext = useContext(CartContext)

  return {
    ...cartContext,
    cartProducts: products || cartContext.cartProducts,
  }
}

export default CartContext
